/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnListHelperService} from '../common/controller/list-helper.service';
import {Component, Inject, OnInit} from '@angular/core';
import * as _ from 'lodash';

import {WorkspaceResource} from '../../components/api/resources/resource/workspace.resource';
import {WorkspaceRegistryService} from '../../components/workspace-registry.service';

@Component({
  standalone: false,
  selector: 'adn-workspace-route-page',
  template: `
    <adn-workspace-list-page
      *ngIf="list"
      [list]="list">
    </adn-workspace-list-page>
  `
})
export class WorkspaceRoutePageComponent implements OnInit {
  list: any = {};

  constructor(
    private readonly adnListHelper: AdnListHelperService,
    @Inject(WorkspaceResource) private readonly Workspace: any,
    @Inject(WorkspaceRegistryService) private readonly WorkspaceRegistry: any
  ) {
  }

  ngOnInit(): void {
    this.adnListHelper.setUpList(this.list, this.Workspace, false, 'workspaceList', {
      afterAction: (workspaces: any[], currentType: string) => {
        _.forEach(workspaces, (workspace) => {
          if (currentType === 'ACTIVE') {
            this.WorkspaceRegistry.update(workspace);
          } else {
            this.WorkspaceRegistry.remove(workspace);
          }
        });
      }
    });
  }
}
